import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Cookie } from 'lucide-react';

const CookiePolicy = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Hero Section */}
      <section className="relative pt-32 pb-12 bg-gradient-to-br from-gray-900 to-gray-800 dark:from-black dark:to-gray-900 text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <Cookie className="w-16 h-16 mx-auto mb-6 text-[#F05627]" />
            <h1 className="text-4xl md:text-5xl font-bold mb-4">{t('cookiePolicy.title')}</h1>
            <p className="text-lg text-gray-300">{t('cookiePolicy.subtitle')}</p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-8 md:p-12">
            <div className="prose prose-lg max-w-none">
              {/* Introduction */}
              <div className="mb-8">
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('cookiePolicy.intro')}</p>
              </div>

              {/* Sections */}
              {t('cookiePolicy.sections').map((section, index) => (
                <div key={index} className="mb-8">
                  <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                    {index + 1}. {section.title}
                  </h2>
                  <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-3">{section.content}</p>
                  {section.items && section.items.length > 0 && (
                    <ul className="list-disc pl-6 space-y-2 text-gray-700 dark:text-gray-300">
                      {section.items.map((item, itemIndex) => (
                        <li key={itemIndex}>
                          {item.name && <strong className="dark:text-white">{item.name}:</strong>} {item.desc}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}

              {/* Note */}
              <div className="mt-8 p-6 bg-blue-50 dark:bg-blue-900/30 rounded-lg border-l-4 border-[#F05627]">
                <p className="text-gray-700 dark:text-gray-300 font-medium">{t('cookiePolicy.note')}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CookiePolicy;